import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    deleteTooltip: translate({
      id: 'global.remove',
    }),
    fieldName: translate({ id: 'orders.edit.validation.customFields.name.label' }),
    fieldValue: translate({ id: 'orders.edit.validation.customFields.value.label' }),
    getMaxLengthText: (maxLength: number) =>
      translate({ id: 'orders.edit.validation.maxLength', values: { maxLength } }),
  }))

  return api
}
